import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { JackingActivityEditPage } from './jacking-activity-edit';
import { SharedModule } from '../../../shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { PipesModule } from '../../../../pipes/pipes.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { DirectivesModule } from '../../../../directives/directives.module';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  declarations: [
    JackingActivityEditPage,
  ],
  imports: [
    DirectivesModule,
    IonicPageModule.forChild(JackingActivityEditPage),
    SharedModule,
    TextMaskModule,
    FoundationModule,
    PipesModule,
    IonicSelectableModule,
  ],
  exports: [
    JackingActivityEditPage
  ]
})
export class JackingActivityEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v1/jacking-activity-edit/jacking-activity-edit.module.ts